import { useContext } from 'react';
import AuthContext from '../context/AuthContext';

export const useMe = () => {
  const { user } = useContext(AuthContext);
  return user;
};
